import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const SchoolFees = () => {
     useEffect(() => {
        document.title = 'School Fees -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  Academics</li> 
     <li>School Fees</li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>School Fees</h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
           <h3>Quarterly Tuition Fee</h3>
           <ul className="list">
              <li>The rate of fees is subject to change from time to time due to the increasing cost of teacher’s salary, maintenance and other expenses. </li> 
              <li>Lapse in payment of fees on time will entail removal from roll. A Student will be re-admitted and re-admission fees will be levied. Fees once paid will be not be refunded. </li>
           </ul>
           <p>Parents are required to submit their ward's tuition fee on a quarterly basis, covering all charges except school transportation. Quarterly fees are due by the 20th day of every quarter. Late payments incur a penalty of Rs. 50/- per month.</p>
      
            <h3>Payment Options</h3>
            <p><b>1.</b> School App: Convenient online payment.</p>
            <p><b>2.</b> Bank Payment: Cheque or cash at our designated bank</p>
            <p><b>3.</b> Online Banking: Contact school Admin office for bank details.</p>
             {/*  <h3>QUARTERLY FEE STRUCTURE-YEAR 2024-25</h3> */}
           </div>
           <div className="table-responsive maintable"><table className="table" border="1"><thead><tr><th colspan="12">FEE STRUCTURE FOR 2026–2027 (Monthly)</th></tr><tr><th></th><th>Nur - UKG</th><th>Class 1st</th><th>Class 2nd</th><th>Class 3rd</th><th>Class 4th</th><th>Class 5th</th><th>Class 6th</th><th>Class 7th</th><th>Class 8th</th><th>Class 9th</th><th>Class 10th</th></tr></thead><tbody><tr><td>TOTAL</td><td>4833</td><td>5083</td><td>5217</td><td>5350</td><td>5483</td><td>5617</td><td>5750</td><td>5883</td><td>6117</td><td>6350</td><td>6500</td></tr></tbody></table></div>
           {/* <div className="table-responsive maintable">
           <table className="table" border="1">
              <thead>
                 <tr>
                    <th colspan="12">FEE STRUCTURE FOR 2024–2025 (Monthly)</th>
                 </tr>
                 <tr>
                    <th></th>
                    <th>Nur - UKG</th>
                    <th>I-V</th>
                    <th>VI-VIII</th>
                    <th>IX-X</th> 
                 </tr>
              </thead>
              <tbody>
                 <tr>
                    <td>TOTAL</td>
                    <td>4334</td>
                    <td>4580</td>
                    <td>5244</td> 
                    <td>5860</td>
                 </tr>
              </tbody>
           </table>
        </div> */}
           {/*            <div className="col-lg-6">
<div className="table-responsive maintable">
<table className="table">
<thead>
<tr><th colspan="2">NUR-UKG</th></tr></thead><tbody><tr><td>Tuition Fee </td><td>7765 </td></tr><tr><td>Convenience Fee </td><td>1525 </td></tr><tr><td>Multimedia Fee </td><td>1466  </td></tr><tr><td>Annual Fee </td><td> 2030 </td></tr><tr><td>Examination fee </td><td> 214 </td></tr><tr><td>Grand Total </td><td><strong>13000</strong></td></tr></tbody>
</table>
</div>
</div>
<div className="col-lg-6">
<div className="table-responsive maintable">
<table className="table">
<thead> 
<tr><th colspan="2"><strong>I-V</strong>  </th></tr></thead><tbody><tr><td>Tuition Fee  </td><td>8650  </td></tr><tr><td>Computer Fee  </td><td>602  </td></tr><tr><td>Multimedia Fee  </td><td>1385  </td></tr><tr><td>Library Fee  </td><td>240  </td></tr><tr><td>Annual Fee  </td><td>2382  </td></tr><tr><td>Examination fee  </td><td>481  </td></tr><tr><td>Grand Total  </td><td><strong>13740</strong>  </td></tr></tbody>
</table>
</div>
</div>
<div className="col-lg-6">
<div className="table-responsive maintable">
<table className="table">
<thead>
<tr><th colspan="2"><strong>VI-VIII</strong> </th></tr></thead><tbody><tr><td>  Tuition Fee  </td><td>9270  </td></tr><tr><td>Computer Fee  </td><td>742  </td></tr><tr><td>Multimedia Fee  </td><td>1606  </td></tr><tr><td>Library Fee  </td><td>432  </td></tr><tr><td>Annual Fee  </td><td>2443  </td></tr><tr><td>Examination fee  </td><td>742  </td></tr><tr><td>Lab Fee  </td><td>495  </td></tr><tr><td>Grand Total  </td><td><strong>15730</strong>  </td></tr></tbody>
</table>
</div>
</div>
<div className="col-lg-6">
<div className="table-responsive maintable">
<table className="table">
<thead>
<tr><th colspan="2"><strong>IX-X</strong>  </th></tr></thead><tbody><tr><td>Tuition Fee  </td><td>9889  </td></tr><tr><td>Computer Fee  </td><td>864  </td></tr><tr><td>Multimedia Fee  </td><td>1855  </td></tr><tr><td>Library Fee  </td><td>555  </td></tr><tr><td>Annual Fee  </td><td>2628  </td></tr><tr><td>Examination fee  </td><td>925  </td></tr><tr><td>Lab Fee  </td><td>864  </td></tr><tr><td>Grand Total  </td><td><strong>17580</strong>  </td></tr></tbody>
</table> 
</div>
  </div> */}
 <div className="col-lg-4">
<div className="table-responsive maintable">
<table className="table">
   <thead>
      <tr>
         <th colspan="2"><strong>XI NON-MEDICAL</strong>  </th>
      </tr>
   </thead>
   <tbody>
      <tr>
         <td>WITHOUT IT</td>
         <td>9517  </td>
      </tr>
      <tr>
         <td>WITH IT </td>
         <td>9350  </td>
      </tr> 
   </tbody>
</table>
</div>
</div>
<div className="col-lg-4">
<div className="table-responsive maintable">
<table className="table">
   <thead>
      <tr>
         <th colspan="2"><strong>XI MEDICAL</strong>  </th>
      </tr>
   </thead>
   <tbody>
      <tr>
         <td>WITHOUT IT</td>
         <td>9517  </td>
      </tr> 
      <tr>
         <td>WITH IT </td>
         <td>9517  </td>
      </tr>
   </tbody>
</table>
</div>
</div>

<div className="col-lg-4">
<div className="table-responsive maintable">
<table className="table">
   <thead>
      <tr>
         <th colspan="2"><strong>XI COMMERCE</strong>  </th>
      </tr>
   </thead>
   <tbody>
      <tr>
         <td>WITHOUT IT</td>
         <td>7583  </td>
      </tr>
      <tr>
         <td>WITH IT </td>
         <td>7750  </td>
      </tr> 
   </tbody>
</table>
</div>
</div>
{/*
<div className='col-md-12'>
  <p><b>For 6th optional Subject Extra of Rs.500/-</b></p>
  <h3>ADMISSION FEES</h3>
  <p>Fee for New Admission Rs. 40,000/-</p>
  <p>Fee for Existing Students Rs. 30,000/-</p>
</div> */}
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default SchoolFees
